import { MEASUREMENT } from 'StateEvents';

// These measurement events may be reported multiple times
// All others (Impressions, Quartiles, Viewability, etc.) should only fire once per session
export default [
  MEASUREMENT.SHARED,
  MEASUREMENT.CLICKED,
  MEASUREMENT.PAUSE,
  MEASUREMENT.RESUME,
  MEASUREMENT.MUTE,
  MEASUREMENT.UNMUTE,
  MEASUREMENT.FULLSCREEN
];


// WEBPACK FOOTER //
// ./src/Services/Reporting/RepeatableRequests.js